var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgScorecardCredit = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 3H7.33334C6.22877 3 5.33334 3.89543 5.33334 5V21L8.83334 19L12.3333 21L15.8333 19L19.3333 21V5C19.3333 3.89543 18.4379 3 17.3333 3Z",
    stroke: "#9594AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 11.5C10.6765 11.5 9.33334 10.6046 9.33334 9.5C9.33334 8.39543 10.6765 7.5 12.3333 7.5M12.3333 11.5C13.9902 11.5 15.3333 12.3954 15.3333 13.5C15.3333 14.6046 13.9902 15.5 12.3334 15.5M12.3333 11.5V7.5M12.3333 11.5L12.3334 15.5M12.3333 7.5C13.4438 7.5 14.4133 7.9022 14.932 8.5M12.3333 7.5V6.5M12.3334 15.5L12.3333 16.5M12.3334 15.5C11.2229 15.5 10.2534 15.0978 9.73471 14.5",
    stroke: "#9594AF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgScorecardCredit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/scorecard-credit.3205a23f.svg";
export { ForwardRef as ReactComponent };